<script setup lang="ts">
const { backgroundColor = 'rgb(from black r g b / 0.8)' } = defineProps<{
  show: boolean;
  backgroundColor?: string;
  center?: boolean;
  blur?: boolean;
}>();
</script>

<template>
  <Teleport v-if="show" to="body">
    <!-- v-bind here to pass the props down into transition so that the v-bind works in the scoped
    css below -->
    <Transition name="fade" v-bind="{ ...$attrs, ...$props }">
      <div v-if="show" class="main-overlay" :class="{ center, blur }">
        <slot />
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.main-overlay {
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  padding: 4em;
  z-index: 20;
  background-color: v-bind('backgroundColor');

  &.blur {
    @supports (backdrop-filter: none) {
      backdrop-filter: blur(4px);
    }
  }

  &.center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
